<template>
  <div>
    <h2 class="chart-heading">{{ chartName | translate }}</h2>
    <v-layout row justify-space-between class="chart-block">
      <v-flex md10 sm8 xs12>
        <div
          style="width:100%;height:430px"
          class="wrap-chart flex charts-align chart full-width-chart"
        ></div>
      </v-flex>
      <v-flex md2 sm4 xs12 pl-3 class="legend-box">
        <chart-labels
          :chart-labels="chartLabels"
          :chart-name="chartName"
          :chart-colors="chartColors"
          @updateLabels="updateAndPlot"
          @updateColors="updateColorsAndPlot"
        ></chart-labels>
      </v-flex>
    </v-layout>
  </div>
</template>
<style>
.chart-heading {
  margin-bottom: 5px;
  padding-left: 20px;
  font-weight: 400;
}
.full-width-chart {
  max-width: 100% !important;
}
.wrap-chart canvas {
  width: 100%;
}
.graph-bg {
  background-color: #e9e9e9;
  border: 1px solid #000;
  padding: 5px;
}
.graph-bg ul {
  padding: 5px;
}
.graph-bg ul li {
  list-style: none;
}
.legend-box {
  padding-left: 20px;
}
@media (min-width: 768px) {
  .legend-box {
    max-width: 236px !important;
    min-width: 236px;
    padding-top: 4px;
    padding-left: 0;
  }
}
@media (max-width: 767px) {
  .vue-swatches__container {
    margin-right: 20px;
    margin-top: -20px;
    border-radius: 6px !important;
    right: inherit !important;
    left: 0;
    margin-left: 20px;
  }
  .chart-block {
    flex-wrap: wrap;
  }
}
</style>
<script>
import ChartLabels from "./../../components/charts/ChartLabels";
import * as chartOptions from "./../../common/ChartsOptions";
import {
  getIndexByLabel,
  getItemFromLocalStorage,
  setItemToLocalStorage
} from "./../../common/HelperFunctions";
import { translate } from "../../common/HelperFunctions";

export default {
  props: {
    //chart name for which chart is to be plotted
    chartName: {
      type: String,
      default: ""
    },
    /*
     * chart data from which all data to plot chart
     * and labels is to be extracted
     */
    chartData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartLabels: [],
      chartColors: getItemFromLocalStorage("chartColors-" + this.chartName)
        ? getItemFromLocalStorage("chartColors-" + this.chartName)
        : [],
      // chartColors: [],
      chartDataToPlot: []
    };
  },
  mounted: function() {
    this.getSortedData();
    this.getLabels();
    this.setColors();
    this.getChartDataToPlot();
    this.plotChart();
  },
  components: {
    ChartLabels
  },
  methods: {
    /*
     * plots chart with data from chartDataToPlot and
     * dataOptions on element having class name chart
     */
    plotChart() {
      $.plot(
        $(this.$el.getElementsByClassName("chart")),
        this.chartDataToPlot,
        this.setChartOptions()
      );
    },
    /*
     * gets data and labels that are to be plotted
     * on the basis of labels stored in local storage
     */
    getChartDataToPlot() {
      let labelsFromLocalStorage = getItemFromLocalStorage(
        "selectedLabels-" + this.chartName
      );
      if (labelsFromLocalStorage) {
        labelsFromLocalStorage.forEach(element => {
          let index = getIndexByLabel(this.chartData, element);
          if (index !== -1) {
            this.chartDataToPlot.push({
              label: this.chartData[index].label,
              data: this.chartData[index].data,
              color: this.chartData[index].color
            });
          }
        });
      }
    },
    /*
     * sets colors from local storage if already present there
     * otherwise at random from array of colors in file chartsOptions
     */
    async setColors() {
      // if (!this.getColorsFromLocalStorage()) {
      await this.getColorsFromLocalStorage();

      this.chartColors.sort((a, b) =>
        parseInt(a.srt) > parseInt(b.srt) ? 1 : -1
      );

      setItemToLocalStorage("chartColors-" + this.chartName, this.chartColors);
      // }
    },
    /*
     * If a components selected colors are present in
     * local storage set colors according to that.
     */
    async getColorsFromLocalStorage() {
      let colorsFromLocalStorage = getItemFromLocalStorage(
        "chartColors-" + this.chartName
      );
      let newDataToSaveInStorage = [];
      if (colorsFromLocalStorage) {
        this.chartData.forEach((data, ind) => {
          let index = getIndexByLabel(colorsFromLocalStorage, data.label);
          if (index >= 0) {
            data.color = colorsFromLocalStorage[index].color;
          } else {
            data.color = chartOptions.chartsColors[ind];
          }
          newDataToSaveInStorage.push({
            label: data.label,
            color: data.color,
            srt: data.srt
          });
        });
        // return true;
      } else {
        this.chartData.forEach((element, index) => {
          element.color = chartOptions.chartsColors[index];
          newDataToSaveInStorage.push({
            label: element.label,
            color: element.color,
            srt: element.srt
          });
        });
        // return false;
      }

      this.chartColors = newDataToSaveInStorage;
    },
    /*
     * gets labels of data that is to send to
     * props in label components
     */
    getLabels() {
      this.chartData.forEach(element => {
        this.chartLabels.push(element.label);
      });
    },
    /*
     * sorts data on the basis of their srt to
     * print labels accordingly
     */
    getSortedData() {
      this.chartData.sort((a, b) =>
        parseInt(a.srt) > parseInt(b.srt) ? 1 : -1
      );
    },
    /*
     * on emit event from child component(labels) it
     * updates chartDataToPlot and plots chart again
     */
    updateAndPlot(e) {
      let dataToPush = this.chartData[
        getIndexByLabel(this.chartData, e.target.value)
      ];
      if (e.target.checked) {
        this.chartDataToPlot.push({
          label: dataToPush.label,
          data: dataToPush.data,
          color: dataToPush.color
        });
      } else {
        this.chartDataToPlot.splice(
          getIndexByLabel(this.chartDataToPlot, dataToPush.label),
          1
        );
      }
      this.plotChart();
    },
    /*
     * updates colors of data when colors changes
     *  and plots again
     */
    updateColorsAndPlot(e, label) {
      let index = getIndexByLabel(this.chartData, label);
      this.chartData[index].color = e;
      index = getIndexByLabel(this.chartDataToPlot, label);
      if (index !== -1) this.chartDataToPlot[index].color = e;

      this.plotChart();
    },
    /*
     * sets chart options to plot including xaxis yaxis
     * legend, grid, tooltip
     */
    setChartOptions() {
      let minMax = this.calculateChartMinMax();
      if (this.chartDataToPlot.length === 0) {
        minMax.max = 1;
        minMax.min = -1;
      } else {
        minMax.max = minMax.max + 1;
        minMax.min = minMax.min - 1;
      }
      //console.log(label);
      return {
        xaxis: {
          mode: "time",
          timeformat: "%H:%M",
          show: true
        },
        yaxis: {
          max: minMax.max,
          min: minMax.min,
          show: true
        },
        legend: {
          show: false
        },
        grid: {
          hoverable: true,
          borderWidth: 2,
          backgroundColor: {
            colors: ["#999", "#ffffff"]
          }
        },
        tooltip: true,
        tooltipOpts: {
          defaultTheme: false,
          content: (label, x, y) => {
            let date = new Date(x).toISOString();
            let dateToShow = date.replace("T", " ").replace(".000Z", " ");
            let tooltip = `<div class="tooltip-content graph-bg"><h4>${
              label ? translate(label) : ""
            }</h4><ul><li>${dateToShow}</li><li>${Number(y).toFixed(
              1
            )}</li></ul></div>`;
            return tooltip;
          }
        }
      };
    },
    /*
     * claculate min and maximum value for x and y axis.
     */
    calculateChartMinMax() {
      let minMax = {
        min: 0,
        max: 0
      };
      for (let i = 0; i < this.chartDataToPlot.length; i++) {
        this.chartDataToPlot[i].data.forEach(data => {
          if (data[1] < minMax.min) {
            minMax.min = data[1];
          }
          if (data[1] > minMax.max) {
            minMax.max = data[1];
          }
        });
      }
      return minMax;
    }
  },
  watch: {
    chartData: function(oldVal, newVal) {
      if (oldVal !== newVal) {
        this.getSortedData();
        this.getLabels();
        this.setColors();
        this.getChartDataToPlot();
        this.plotChart();
      }
    }
  }
};
</script>
